import { render, staticRenderFns } from "./AlbumEditPages.vue?vue&type=template&id=5f9a2d68&scoped=true"
import script from "./AlbumEditPages.vue?vue&type=script&lang=js"
export * from "./AlbumEditPages.vue?vue&type=script&lang=js"
import style0 from "./AlbumEditPages.vue?vue&type=style&index=0&id=5f9a2d68&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a2d68",
  null
  
)

export default component.exports